import { normalizeReportFilters, } from '../../pages/Reports/Filters/reportFilterRegistry';
import { applyDynamicReportFilters, } from '../../pages/Reports/Filters/reportFilterUtils';


export function applyFilters(allData, filters = {}, reportConfig = {}) {
    const resolvedFilters = resolveFilters(filters);
    const cohortData = buildReportDataset(allData, resolvedFilters, reportConfig);
    console.log( 'cohortData:', cohortData );
    return applyAttributeFilters(cohortData, resolvedFilters, reportConfig);
}

export function resolveFilters(filters = {}) {
    const [startDate, endDate] = getDateRange(filters);

    return {
        ...filters,
        startDate,
        endDate,
        monthDayRange: getRecurringWindow(startDate, endDate),
    };
}

export function buildReportDataset(allData = [], filters = {}, reportConfig = {}) {
    if (filters.dateRange === 'all') {
        return allData;
    }

    const datasetMode = reportConfig.datasetMode || 'cohort';

    if (datasetMode === 'flow') {
        return buildFlowDataset(allData, filters, reportConfig);
    }

    return buildCohortDataset(allData, filters, reportConfig);
}

export function buildCohortDataset(allData = [], filters = {}, reportConfig = {}) {
    const dateFields = getCohortDateFields(filters, reportConfig);

    if (filters.dateRange === 'all' || !dateFields.length) {
        return allData;
    }

    const cohortConfig = {
        ...reportConfig,
        dateFields,
    };

    return allData.filter((item) =>
        applyFilters_itemPassesDateRange(item, cohortConfig, filters)
    );
}

export function buildFlowDataset(allData = [], filters = {}, reportConfig = {}) {
    const dateFields =
        reportConfig.flowDateFields ||
        reportConfig.dateFields ||
        [];

    if (!dateFields.length) {
        return allData;
    }

    const flowConfig = {
        ...reportConfig,
        dateFields,
    };

    console.log( 'flowConfig:', flowConfig );
    return allData.filter((item) =>
        applyFilters_itemPassesDateRange(item, flowConfig, filters)
    );
}

export function applyAttributeFilters(data, filters, reportConfig) {
    const filterDefs = normalizeReportFilters(reportConfig);
  
    return applyDynamicReportFilters(data, filters, filterDefs);
}

export function getCohortDateFields(filters = {}, reportConfig = {}) {
    if (filters.cohortStart && reportConfig?.milestoneDateFieldMap?.[filters.cohortStart]) {
        return [reportConfig.milestoneDateFieldMap[filters.cohortStart]];
    }

    if (filters.cohortStart) {
        return [filters.cohortStart];
    }

    if (reportConfig?.dateFields?.length) {
        return reportConfig.dateFields;
    }

    return ['createdDate'];
}

function applyFilters_itemPassesDateRange(item, reportConfig = {}, filters = {}) {
    const dateFieldDefs = normalizeDateFields(reportConfig.dateFields || ['createdDate']);
    const start = filters.startDate || null;
    const end = filters.endDate || null;
    const recurringRange = filters.monthDayRange || null;

    if (filters.dateRange === 'all') return true;
    if (!start && !end) return true;

    return dateFieldDefs.some( ( fieldDef ) => {
        const raw = getItemDateValue(item, fieldDef.key);
        if (!raw) return false;

        const itemDate = parseFilterDate(raw);
        if (!itemDate) return false;

        if (fieldDef.ignoreYear) {
            return recurringDateInRange(itemDate, recurringRange);
        }

        if (start && itemDate < start) return false;
        if (end && itemDate > end) return false;

        return true;
    } );
}

function getItemDateValue(item, key) {
    if (!item || !key) return null;

    if (item.milestones?.[key]) return item.milestones[key];
    if (item[key]) return item[key];
    
    return null;
}

function parseFilterDate(raw) {
    if (!raw) return null;

    if (raw instanceof Date) {
        return isNaN(raw.getTime()) ? null : raw;
    }

    if (typeof raw === 'string') {
        const dt = new Date(raw.includes('T') ? raw : `${raw}T12:00:00`);
        return isNaN(dt.getTime()) ? null : dt;
    }

    return null;
}

function startOfDay(d) {
    const x = new Date(d);
    x.setHours(0, 0, 0, 0);
    return x;
}

function endOfDay(d) {
    const x = new Date(d);
    x.setHours(23, 59, 59, 999);
    return x;
}

function addDays(date, days) {
    const d = new Date(date);
    d.setDate(d.getDate() + days);
    return d;
}

function startOfYear(date) {
    return new Date(date.getFullYear(), 0, 1);
}

function startOfMonth(d) {
    return new Date(d.getFullYear(), d.getMonth(), 1, 0, 0, 0, 0);
}

function endOfMonth(d) {
    return new Date(d.getFullYear(), d.getMonth() + 1, 0, 23, 59, 59, 999);
}

function startOfWeek(d, weekStart = 0) {
    const dt = startOfDay(d);
    const day = dt.getDay();
    let diff = day - weekStart;
    if (diff < 0) diff += 7;
    return addDays(dt, -diff);
}

function endOfWeek(d, weekStart = 0) {
    const s = startOfWeek(d, weekStart);
    return endOfDay(addDays(s, 6));
}

function startOfQuarter(date) {
    const quarter = Math.floor(date.getMonth() / 3);
    return new Date(date.getFullYear(), quarter * 3, 1, 0, 0, 0, 0);
}

function endOfQuarter(date) {
    const start = startOfQuarter(date);
    return new Date(start.getFullYear(), start.getMonth() + 3, 0, 23, 59, 59, 999);
}

function dayOfYear(date) {
    const start = startOfYear(date);
    return Math.floor((date - start) / 86400000) + 1;
}

function normalizeDateFields(dateFields) {
    return (dateFields || []).map((f) => {
        if (typeof f === 'string') return { key: f, ignoreYear: false };
        return { key: f.key, ignoreYear: !!f.ignoreYear };
    });
}

function normalizeNumber( value ) { 
    if ( value === null || value === undefined ) return null; 
    if ( typeof value === 'number' ) return value; 
    if ( typeof value === 'string' ) { 
        const cleaned = value.replace( /[$,]/g, '' ).trim(); 
        const num = parseFloat( cleaned ); 
        return isNaN( num ) ? null : num; 
    } 
    return null; 
} 

function normalizeRate( value ) { 
    if ( value === null || value === undefined ) return null; 
    let num; 
    if ( typeof value === 'number' ) { 
        num = value; 
    } else if ( typeof value === 'string' ) { 
        const cleaned = value.replace( /[%]/g, '' ).trim(); 
        num = parseFloat( cleaned ); 
    } else { 
        return null; 
    } 
    
    if ( isNaN( num ) ) return null; 
    
    // If it's ≤ 1, assume it's a decimal fraction (e.g., 0.0625) → convert to percent 
    if ( num <= 1 ) num = num * 100; 
    return num; 
}

export function getMonthDayNumber(date) {
    const d = new Date(date);
    if (Number.isNaN(d.getTime())) return null;
    return (d.getMonth() + 1) * 100 + d.getDate(); // Apr 8 => 408
}

export function getRecurringWindow(start, end) {
    const startMD = getMonthDayNumber(start);
    const endMD = getMonthDayNumber(end);
  
    return {
        start,
        end,
        startMD,
        endMD,
        wrapsYear: startMD > endMD,
    };
}

export function recurringDateInRange(itemDate, recurringRange) {
    if (!itemDate) return false;

    const itemMD = getMonthDayNumber(itemDate);
    const { startMD, endMD, wrapsYear } = recurringRange || {};

    if (itemMD == null) return false;
    if (startMD == null && endMD == null) return true;
    if (startMD == null) return itemMD <= endMD;
    if (endMD == null) return itemMD >= startMD;

    if (!wrapsYear) {
        return itemMD >= startMD && itemMD <= endMD;
    }

    return itemMD >= startMD || itemMD <= endMD;
}

export function getDateRange(filters = {}) {
    const now = new Date();
    let start = null;
    let end = null;
    const monthMap = {
        january: 0,
        february: 1,
        march: 2,
        april: 3,
        may: 4,
        june: 5,
        july: 6,
        august: 7,
        september: 8,
        october: 9,
        november: 10,
        december: 11,
    };

    const dr = filters.dateRange || 'all';

    // dynamic patterns: nextXdays
    const nextMatch = /^next(\d+)days$/i.exec(dr);
    if (nextMatch) {
        const days = parseInt(nextMatch[1], 10);
        start = startOfDay(now);
        end = endOfDay(addDays(now, days));
        return [start, end];
    }

    // dynamic patterns: lastXdays
    const lastMatch = /^last(\d+)days$/i.exec(dr);
    if (lastMatch) {
        const days = parseInt(lastMatch[1], 10);
        end = endOfDay(now);
        start = startOfDay(addDays(now, -days));
        return [start, end];
    }

    switch (dr) {
        case 'today':
            start = startOfDay(now);
            end = endOfDay(now);
            break;

        case 'yesterday':
            start = startOfDay(addDays(now, -1));
            end = endOfDay(addDays(now, -1));
            break;

        case 'tomorrow':
            start = startOfDay(addDays(now, 1));
            end = endOfDay(addDays(now, 1));
            break;

        case 'thisWeek': {
            const weekStart = filters.weekStart ?? 0;
            start = startOfWeek(now, weekStart);
            end = endOfWeek(now, weekStart);
            break;
        }

        case 'lastWeek': {
            const weekStart = filters.weekStart ?? 0;
            const thisWeekStart = startOfWeek(now, weekStart);
            start = addDays(thisWeekStart, -7);
            end = endOfWeek(start, weekStart);
            break;
        }

        case 'nextWeek': {
            const weekStart = filters.weekStart ?? 0;
            start = addDays(startOfWeek(now, weekStart), 7);
            end = endOfWeek(start, weekStart);
            break;
        }

        case 'thisMonth':
            start = startOfMonth(now);
            end = endOfMonth(now);
            break;

        case 'lastMonth': {
            const last = new Date(now.getFullYear(), now.getMonth() - 1, 1);
            start = startOfMonth(last);
            end = endOfMonth(last);
            break;
        }

        case 'nextMonth': {
            const next = new Date(now.getFullYear(), now.getMonth() + 1, 1);
            start = startOfMonth(next);
            end = endOfMonth(next);
            break;
        }

        case 'thisQuarter':
            start = startOfQuarter(now);
            end = endOfQuarter(now);
            break;

        case 'lastQuarter': {
            const currentQuarterStart = startOfQuarter(now);
            const lastQuarterRef = addDays(currentQuarterStart, -1);
            start = startOfQuarter(lastQuarterRef);
            end = endOfQuarter(lastQuarterRef);
            break;
        }

        case 'wtd':
            start = startOfWeek(now);
            end = endOfDay(now);
            break;

        case 'mtd':
            start = startOfMonth(now);
            end = endOfDay(now);
            break;

        case 'qtd':
            start = startOfQuarter(now);
            end = endOfDay(now);
            break;
    
        case 'ytd':
            start = startOfYear(now);
            end = endOfDay(now);
            break;

        case 'thisYear':
            start = startOfYear(now);
            end = new Date(now.getFullYear(), 11, 31, 23, 59, 59, 999);
            break;

        case 'lastYear':
            start = new Date(now.getFullYear() - 1, 0, 1, 0, 0, 0, 0);
            end = new Date(now.getFullYear() - 1, 11, 31, 23, 59, 59, 999);
            break;

        case 'custom':
            start = filters.startDate ? startOfDay(new Date(filters.startDate)) : null;
            end = filters.endDate ? endOfDay(new Date(filters.endDate)) : null;
            break;

        case 'all':
        default:
            if ( dr in monthMap ) {
                const monthIndex = monthMap[dr];
                start = new Date( now.getFullYear(), monthIndex, 1 );
                end = new Date( now.getFullYear(), monthIndex + 1, 0 );
                start.setHours( 0, 0, 0, 0 );
                end = endOfDay( end );
            } else {
                start = null;
                end = null;
            }
            break;
    }

    return [start, end];
}